import './App.scss';
import ServiceProvider from "./pages/ServiceProvider";
import Reserve from "./pages/Reserve";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import {ThemeProvider} from "@mui/material";
import {useState, useEffect, useContext} from "react";
import greenTheme from "./components/themes/GreenTheme";
import blueTheme from "./components/themes/BlueTheme";
import greyTheme from "./components/themes/GreyTheme";
import purpleTheme from "./components/themes/PurpleTheme";
import powderTheme from "./components/themes/PowderTheme";
import NotFound from "./pages/NotFound";
import SuccessfulReservation from "./pages/SuccessfulReservation";
import {Helmet} from "react-helmet";
import Simple from "./pages/Simple";
import ReservationResignation from "./pages/ReservationResignation";
import Products from "./pages/Products";
import Checkout from "./pages/Checkout";
import ConfigContext from "./context/ConfigContext";
import SuccessfulOrder from "./pages/SuccessfulOrder";
import {CartProvider} from "./context/CartContext";
import honvedTheme from "./components/themes/HonvedTheme";


function App() {
    const [theme, setTheme] = useState(greenTheme)
    const {config} = useContext(ConfigContext);

    const themeMap = {
        'blue': blueTheme,
        'grey': greyTheme,
        'green': greenTheme,
        'purple': purpleTheme,
        'powder': powderTheme,
        'honved': honvedTheme,
    }

    useEffect(() => {
        setTheme(themeMap[config?.theme])
    }, [config])

    const webShopNeeded = config?.usage_type === 'website_webshop'
    return <ThemeProvider theme={theme}>
        <CartProvider>
            <Helmet>
                <meta name="theme-color" content={theme.palette.primary[700]}/>
            </Helmet>
            <Router>
                <Switch>
                    <Route path="/" component={Reserve} exact/>
                    <Route path="/book" component={Reserve} exact/>
                    <Route path="/success" component={SuccessfulReservation} exact/>
                    <Route path="/resignation/:slug" component={ReservationResignation} exact/>
                    {webShopNeeded && <Route path="/products" component={Products} exact/>}
                    {webShopNeeded && <Route path="/checkout" component={Checkout} exact/>}
                    {webShopNeeded && <Route path="/order-success" component={SuccessfulOrder} exact/>}
                    <Route path="/adattovabbitasi-nyilatkozat" component={Simple} exact/>
                    <Route component={NotFound}/>
                </Switch>
            </Router>
        </CartProvider>
    </ThemeProvider>
}

export default App;